export type ChooseDoubleRewardsChoice = 'points' | 'statusCredits'

export interface ChooseDoubleRewardsCampaignMetadata {
  decisionGroup: string
  doublePointsChoiceId: string
  doubleStatusCreditsChoiceId: string
  endsAt: Date
  /** Should match App.OfferType */
  supportedProductTypes: Array<string>
}

export type ChooseDoubleRewardsMemberState =
  | { status: 'unenrolled' }
  | { status: 'enrolled', choice: ChooseDoubleRewardsChoice }
  | { status: 'unavailable' }

/** Only recognise a resolved choice belonging to this campaign. */
export function resolveLoyaltyChooseDoubleRewardsMemberState(
  decisions: App.LoyaltyAccount['earnDecisions'] | undefined,
  config: ChooseDoubleRewardsCampaignMetadata | undefined,
): ChooseDoubleRewardsMemberState {
  if (!config) return { status: 'unavailable' }

  const matchingDecisionGroups = (decisions ?? []).filter(decision => decision.group === config.decisionGroup)
  // New accounts have no decisions yet, so they are unenrolled
  if (!matchingDecisionGroups.length) return { status: 'unenrolled' }
  if (matchingDecisionGroups.length !== 1) return { status: 'unavailable' }

  const [decision] = matchingDecisionGroups
  if (decision.status !== 'RESOLVED') return { status: 'unavailable' }
  if (!decision.selectedCatalogIds.length) return { status: 'unenrolled' }
  if (decision.selectedCatalogIds.length !== 1) return { status: 'unavailable' }

  const [catalogId] = decision.selectedCatalogIds
  switch (catalogId) {
    case config.doublePointsChoiceId:
      return { status: 'enrolled', choice: 'points' }
    case config.doubleStatusCreditsChoiceId:
      return { status: 'enrolled', choice: 'statusCredits' }
    default:
      return { status: 'unavailable' }
  }
}
